<!-- 我的交易 -->
<template>
  <div class="container">
    <div class="title">
      <div class="leftLine1" v-if="current !== 'detail'">
        <p class="p1">产品类型</p>
        <div class="line"></div>
        <el-button @click="current = 'my'" class="btns" :class="current === 'my' ? 'active' : ''" size="small"
          style="margin-right: 10px">自己的订单列表（我的支出）</el-button>
        <el-button @click="current = 'collection'" class="btns" :class="current === 'collection' ? 'active' : ''" size="small"
          style="margin-right: 10px">收款订单列表（我的收入）</el-button>
        <el-button @click="current = 'ke'" class="btns" :class="current === 'ke' ? 'active' : ''" size="small"
          style="margin-right: 10px">客户下单及利润列表（我的佣金）</el-button>
        <!-- <el-button
          @click="current = 'sh'"
          class="btns"
          :class="current === 'sh' ? 'active' : ''"
          size="small"
          >收款订单（我的收入）</el-button
        > -->
      </div>
      <expend @updateCurrent="updateCurrent" v-if="current === 'my'"></expend>
      <income1 v-else-if="current === 'ke'"></income1>
      <my-colletion-order v-else-if="current === 'collection'"></my-colletion-order>
      <orderDetail :datas="datas" @updateCurrent="updateCurrent" v-else></orderDetail>
      <!-- <myIncome v-else></myIncome> -->
    </div>
  </div>
</template>

<script>
import expend from "./child/expend.vue";
import income1 from "./child/income1.vue";
import orderDetail from "./child/orderDetail.vue";
import myIncome from './child/myIncome.vue';
import MyColletionOrder from './child/myColletionOrder.vue';
export default {
  components: {
    expend,
    income1,
    orderDetail,
    myIncome,
    MyColletionOrder
  },
  data() {
    return {
      datas: {},//传过来的数据接收
      current: "my",
    };
  },
  computed: {},
  watch: {},
  methods: {
    updateCurrent(val, data) {
      console.log(val, data, '传过来的数据');
      if (data) {
        this.datas = data
      }
      this.current = val
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
/deep/.el-button {
  border: none;
}

/deep/ .el-radio {
  margin-right: 10px;
}

.container {
  background-color: #fff;
  padding: 0.2rem;

  .active {
    background-color: #dc6d33 !important;
    color: #fff !important;
  }

  .leftLine1 {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;

    .p1 {
      color: #db6e33;
      font-size: 0.12rem;
      font-family: SourceHanSansSC-bold;
      font-weight: bold;
      width: 0.8rem;
      text-align: right;
    }

    .line {
      height: 0.3rem;
      width: 1px;
      border-right: 1px solid var(--color);
      margin: 0 0.1rem;
    }

    .btns {
      background-color: #f7e1d3;
      color: #db6e33;
    }

    .btns1 {
      background-color: #fff;
      color: #db6e33;
      border: 1px solid #db6e33;
    }

    .rightBox {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
